import { UserNotificationPreferencesGetResultAjax } from './user-notification-preferences.backend-model';
import { UserNotificationPreferences } from './user-notification-preferences.model';

export function transformRawUserNotificationPreferences(
  preferences: UserNotificationPreferencesGetResultAjax,
  authUid: string,
): UserNotificationPreferences {
  const {
    announcement,
    bid_private_message: bidPrivateMessage,
    bid_update_frequency: bidUpdateFrequency,
    bid_update: bidUpdate,
    community_digest: communityDigest,
    contacts_request: contactsRequest,
    contest_entry: contestEntry,
    contest_private_message: contestPrivateMessage,
    contest_top_contest: contestTopContest,
    deals,
    email_format: emailFormat,
    group_comment: groupComment,
    group_post: groupPost,
    latest_projects_contests_frequency: latestProjectsContestsFrequency,
    latest_projects_contests: latestProjectsContests,
    local_project_transactionals: localProjectTransactionals,
    local_projects_sms: localProjectsSms,
    marketing,
    marketplace,
    milestone_release: milestoneRelease,
    nearby_local_projects: nearbyLocalProjects,
    newsletter,
    private_message_from_contact: privateMessageFromContact,
    private_message: privateMessage,
    project_awarded: projectAwarded,
    project_contest_message: projectContestMessage,
    receive_sms: receiveSms,
    recommend_top_freelancer: recommendTopFreelancer,
    recruiter_contact: recruiterContact,
    referral,
    services,
    sites,
    staff_message: staffMessage,
  } = preferences;

  return {
    id: authUid,
    announcement,
    bidPrivateMessage,
    bidUpdateFrequency,
    bidUpdate,
    communityDigest,
    contactsRequest,
    contestEntry,
    contestPrivateMessage,
    contestTopContest,
    deals,
    emailFormat,
    groupComment,
    groupPost,
    latestProjectsContestsFrequency,
    latestProjectsContests,
    localProjectTransactionals,
    localProjectsSms,
    marketing,
    marketplace,
    milestoneRelease,
    nearbyLocalProjects,
    newsletter,
    privateMessageFromContact,
    privateMessage,
    projectAwarded,
    projectContestMessage,
    receiveSms,
    recommendTopFreelancer,
    recruiterContact,
    referral,
    services,
    sites,
    staffMessage,
  };
}
